import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@material-ui/core';

import TlSubheader from 'ondemand/components/TlSubheader';
import {getDays, getTimes} from 'ondemand/utils/gtfs';

import styles from './AgencyServiceList.css';


const agencyNameStyle = {
  fontWeight: 400,
  fontSize: '14px',
};

const changeButtonStyle = {
  float: 'right',
  fontSize: '13px',
  fontWeight: 500,
  color: '#4a90e2',
  cursor: 'pointer',
};

const dividerStyle = {
  marginTop: '8px',
  marginBottom: '8px',
  marginLeft: '24px',
  marginRight: '24px',
};

const serviceTitleStyle = {
  color: '#919191',
  paddingLeft: '24px',
  paddingRight: '24px',
};

const listItemStyle = {
  paddingLeft: '24px',
  paddingRight: '24px',
};

const serviceNameStyle = {
  fontWeight: 400,
  fontSize: '14px',
};

const daysTimesStyle = {
  fontSize: '13px',
  color: '#000',
};

const AgencyServiceList = ({agency, agencySettings, services, onAgencyClick}) => {
  const sortedServices = _.sortBy(services, 'name');
  const serviceNodes = _.map(sortedServices, service => {
    const days = getDays(service);
    const times = getTimes(service);
    const primaryText = <span style={serviceNameStyle}>{service.name}</span>;
    const secondaryText = <span style={daysTimesStyle}>{`${days}, ${times}`}</span>;
    return (
      <ListItem
        data-id={'service-list-row'}
        key={service.service_id}
        style={listItemStyle}
      >
        <span hidden data-id={'service-id'}>{service.service_id}</span>
        <ListItemText
          data-id={'service-data'}
          primary={primaryText}
          secondary={secondaryText}
        />
      </ListItem>
    );
  });

  const agencyInfo = (
    <span>
      <span
        data-id={'edit-agency-button'}
        style={changeButtonStyle}
        onClick={onAgencyClick}
      >
        Change
      </span>
      <span
        data-id={'agency-name'}
        style={agencyNameStyle}
      >
        {agency.long_name}
      </span>
    </span>
  );

  const agencyContact = (
    <span>
      {agencySettings.email &&
        <span>
          <span className={styles.contactTitle}>Email</span>
          <a
            className={styles.contactLink}
            href={`mailto:${agencySettings.email}`}
            data-id="agency-email"
          >
            {agencySettings.email}
          </a>
        </span>
      }
      {agencySettings.phone &&
        <span>
          <span className={styles.contactTitle}>Phone</span>
          <a
            className={styles.contactLink}
            href={`tel:${agencySettings.phone}`}
            data-id="agency-phone"
          >
            {agencySettings.phone}
          </a>
        </span>
      }
      <Divider style={dividerStyle} />
    </span>
  );

  return (
    <List>
      <ListItem style={listItemStyle}>
        <ListItemText primary={agencyInfo} />
      </ListItem>

      <Divider style={dividerStyle} />

      {(agencySettings.email || agencySettings.phone) && agencyContact}

      <div data-id={'service-list'}>
        <TlSubheader style={serviceTitleStyle}>Service List</TlSubheader>

        {serviceNodes}
      </div>
    </List>
  );
};

AgencyServiceList.propTypes = {
  agency: PropTypes.object.isRequired,
  agencySettings: PropTypes.object.isRequired,
  services: PropTypes.array.isRequired,
  onAgencyClick: PropTypes.func.isRequired,
};

export default AgencyServiceList;



// WEBPACK FOOTER //
// ./src/ondemand/components/AgencyServiceList/AgencyServiceList.js